// extracted by mini-css-extract-plugin
export var attachment = "_qu-a";
export var emailContainer = "_qu-4";
export var emailContentPaddedContainer = "_qu-b";
export var emailHeader = "_qu-6";
export var emailIframe = "_qu-3";
export var emailInfoIcon = "_qu-9";
export var emailShortenedSummary = "_qu-e";
export var infoDropdown = "_qu-0";
export var infoRowBoundedContent = "_qu-d";
export var internal = "_qu-5";
export var merchant = "_qu-8";
export var messageInputContainer = "_qu-h";
export var normal = "_qu-7";
export var replyCard = "_qu-f";
export var subtleButton = "_qu-1";
export var subtleButtonIconContainer = "_qu-2";
export var toggleViewRepliesButton = "_qu-c";
export var wrappingText = "_qu-g";